<div class="page-loading" *ngIf="!content">Loading...</div>
<div class="legacy-page" *ngIf="content" [innerHTML]="content" (click)="onContentClick($event)" (submit)="onContentSubmit($event)"></div>
<div class="container" *ngIf="formMessage">
  <p class="angular-form-message">{{ formMessage }}</p>
</div>
